/* global FormData */
import React from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import {
  Dialog
} from 'material-ui'
import { CardTitle } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import DeleteIcon from 'material-ui/svg-icons/action/delete'

import api from '../../api'
import FileInput from '../file-input'
import { setSnackbarMessage } from '../../actions/snackbar'

const buttonStyle = {
  margin: '1em 1em 0 0'
}

class EditMedia extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      errors: {},
      resource: {},
      showDelete: false
    }
  }

  componentWillMount () {
    this.getResource()
  }

  getResource () {
    api.get(`admin/media/${this.props.params.mediaId}`)
      .then(res => res.json())
      .then(resource => this.setState({ resource }))
  }

  handleNameChange (e, newValue) {
    e.preventDefault()
    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        name: newValue
      }
    }))
  }

  handleFileChange (file) {
    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        file
      }
    }))
  }

  render () {
    const deleteActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleDeleteClose.bind(this)}
      />,
      <FlatButton
        label='Delete'
        primary
        keyboardFocused
        onClick={this.handleDeleteConfirm.bind(this)}
      />
    ]

    return (
      <div>
        <CardTitle title='Edit Media' style={{ paddingLeft: 0 }} />
        <form onSubmit={this.handleSubmit.bind(this)}>
          <TextField
            name='name'
            floatingLabelText='Name'
            value={this.state.resource.name || ''}
            errorText={this.state.errors.name}
            onChange={this.handleNameChange.bind(this)}
          />

          <div style={{ marginBottom: '1em' }}>
            <FileInput
              label='Change File'
              onFileSelected={this.handleFileChange.bind(this)}
            />
            <p>
              Current File: {this.state.resource.file
                ? this.state.resource.file.name
                : <a href={this.state.resource.url} target='_blank' rel="noreferrer">{this.state.resource.file_name}</a>}
            </p>
            {this.state.errors.file &&
              <p style={{ color: 'red' }}>{this.state.errors.file.join(' ')}</p>}
          </div>

          <RaisedButton
            label='Save'
            primary
            onClick={this.handleSubmit.bind(this)}
            style={buttonStyle}
          />

          <RaisedButton
            label='Cancel'
            onClick={this.handleCancel.bind(this)}
            style={buttonStyle}
          />

          <FlatButton
            label='Delete'
            secondary
            onClick={this.handleDeleteOpen.bind(this)}
            icon={<DeleteIcon />}
            style={buttonStyle}
          />
        </form>

        <Dialog
          title='Confirm delete'
          actions={deleteActions}
          modal={false}
          open={this.state.showDelete}
          onRequestClose={this.handleDeleteClose.bind(this)}
        >
          Are you sure you want to delete this record?
        </Dialog>
      </div>
    )
  }

  handleSubmit (e) {
    e.preventDefault()

    const formData = new FormData()
    if (this.state.resource.name) {
      formData.append('name', this.state.resource.name)
    }
    if (this.state.resource.file) {
      formData.append('file', this.state.resource.file)
    }

    api.patchFile(`admin/media/${this.state.resource.id}`, { body: formData })
      .then(res => res.json().then(data => {
        if (!res.ok) {
          this.setState({ errors: data.errors })
          return
        }
        this.props.setSnackbarMessage('Media update successful')
        browserHistory.push('/media')
      }))
  }

  handleDeleteOpen () {
    this.setState({
      showDelete: true
    })
  }

  handleDeleteClose () {
    this.setState({
      showDelete: false
    })
  }

  handleDeleteConfirm (e) {
    e.preventDefault()
    api.del(`admin/media/${this.state.resource.id}`)
      .then(res => res.json())
      .then(data => {
        this.props.setSnackbarMessage(`Successfully deleted ${this.state.resource.name}`)
        browserHistory.goBack()
      })
  }

  handleCancel (e) {
    e.preventDefault()
    browserHistory.goBack()
  }
}

export default connect(null, { setSnackbarMessage })(EditMedia)
